'use client';

import type {
  ProductDetailData,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Paragraph } from '../../../ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function ProductTabsDescription({
  product,
  selectedVariant,
}: {
  product: ProductDetailData;
  selectedVariant?: VariantsEntity;
}) {
  const { t } = useTranslations();

  const tableData = [
    {
      label: t('text175'),
      value: product?.manufacturers?.[0]?.name,
    },
    {
      label: t('text1462'),
      value: `${product.width} x ${product.height} x ${product.length} m`,
    },
    {
      label: t('text2481'),
      value: product?.code,
    },
    {
      label: t('text3393'),
      value: product?.ean,
    },
  ];

  return (
    <div
      className={cn(
        'flex flex-col items-start justify-start gap-6 md:flex-row md:items-start md:justify-between',
      )}
    >
      <div className="flex w-full max-w-[792px] flex-col items-start justify-start gap-4">
        <h2 className="h5 font-semibold uppercase text-black">{t('text231')}</h2>
        <Paragraph
          innerHtml={selectedVariant?.description || product.description}
          className={cn('w-full md:max-w-[652px]', 'ea-product-tabs-description__content')}
        />
      </div>
      {/* <div className="flex w-full max-w-[384px] flex-col items-start justify-start gap-6 rounded-[4px] bg-[#faf6e5] px-6 pb-6 pt-4">
        {tableData.map(row => (
          <div
            key={row.label}
            className="grid w-full grid-cols-2 gap-0 border-b border-b-border py-2"
          >
            <Paragraph size="sm">{row.label}:</Paragraph>
            <strong className="text-xs font-semibold text-black sm:text-sm">{row.value}</strong>
          </div>
        ))}
      </div> */}
    </div>
  );
}
